const GRID_SELECTOR = 'results-list [ref="grid"]';
const CARD_SELECTOR = ':scope > [data-group-key]';

function dedupGrid(grid) {
  const seen = new Set();
  for (const card of grid.querySelectorAll(CARD_SELECTOR)) {
    const key = card.dataset.groupKey;
    if (!key) continue;
    if (seen.has(key)) {
      card.remove();
    } else {
      seen.add(key);
    }
  }
}

function observeGrid(grid) {
  dedupGrid(grid);

  const observer = new MutationObserver((mutations) => {
    const hasAdditions = mutations.some((m) => m.addedNodes.length > 0);
    if (hasAdditions) dedupGrid(grid);
  });
  observer.observe(grid, { childList: true });
}

function init() {
  const grid = document.querySelector(GRID_SELECTOR);
  if (grid) observeGrid(grid);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
